<script>
export default {
    name: "RawData",
    props: {
        data: {
            type: Object,
            default: () => null,
        },
        placement: {
            type: String,
            default: "left",
        },
        keyId: {
            type: String,
            default: "",
        },
    },
    data(){
        return {
            filter: "",
        }
    },
    computed: {
        rawData() {
            const asArray = Object.entries(this.data);
            const filtered = asArray.filter(([key, value]) =>  value?.toString().toUpperCase().includes(this.filter.toUpperCase()) || key?.toString().toUpperCase().includes(this.filter.toUpperCase()));
            const data = Object.fromEntries(filtered);
            return JSON.stringify(data, null, 2)
        },
        reversePlacement() {
            if(this.placement === "left"){
                return "right";
            }
            if(this.placement === 'bottom'){
                return "bottom";
            }
            return "left";
        },
    },
    methods: {
        viewCode(data) {
            this.$emit("view-code", data)
        },
    }
}
</script>
<template>
    <div 
        class="position-absolute" 
        style="top:-5px;"
        :style="placement === 'left' ? 'left:-5px;' : 'right:-5px;'"
    >
        <a 
            href="javascript:void(0);" 
            @click="viewCode(data)"
            :id="`view-code-${!keyId ? data.id : keyId}`"
        >
            <i class="bx bx-code-alt fs-4"></i>
        </a>
        <b-popover 
            :target="`view-code-${!keyId ? data.id : keyId}`"
            triggers="click blur"
            :placement="reversePlacement"
            custom-class="popover-code"
        >
            <div>
                <input type="text" class="form-control form-control-sm" v-model="filter" placeholder="Search key or value of object">
            </div>
            <div>
                <pre class="font-size-12">{{ rawData }}</pre>
            </div>
        </b-popover>
    </div>
</template>